import object from '@mailobj-browser/front/js/utils/object.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import dragOver from '@mailobj-browser/front/js/events/types/dragOver.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import stopImmediatePropagation from '@mailobj-browser/front/js/events/hooks/stopImmediatePropagation.js'
import drop from '@mailobj-browser/front/js/events/types/drop.js'

const inputs = new WeakMap()

const onDragOver = object(listener, {
  type: dragOver,
  task: (label, event) => {
    preventDefault(event)
    stopImmediatePropagation(event)
  }
})

const onDrop = object(listener, {
  type: drop,
  task: (label, event) => {
    const { dataTransfer } = event
    const { files } = dataTransfer
    
    preventDefault(event)
    stopImmediatePropagation(event)
    inputs.get(label).files = files
  }
})

export default input => {
  const label = closest('label', input)
  
  inputs.set(label, input)
  onDragOver.listen(label)
  onDrop.listen(label)
  
  queueMicrotask(async () => {
    await removed(label)
    inputs.delete(label)
  })
}
